import React from 'react';
import ModernNode from './ModernNode';
import { NODE_TYPES } from '../../config/nodeConfig';

const StateHistoryNode = (props) => {
  return <ModernNode {...props} nodeType={NODE_TYPES.STATE_HISTORY} />;
};

export default StateHistoryNode;
